import CatalogApi from '../api'
import DocumentsApi from '../../documents/api'

export const loadDocuments = async ({ commit }) => {
  let response = await CatalogApi.getAvailableDocuments()
  if (response.success) {
    commit('UPDATE_DOCUMENTS_LIST', response.data)
  } else {
    commit('SET_ERROR', response.error)
  }
}

export const loadCurrentDocument = async ({ commit }, currentDocument) => {
  let response = await CatalogApi.getCurrentDocument({
    id: currentDocument.id,
    name: currentDocument.name
  })
  if (response.success) {
    commit('UPDATE_CURRENT_DOCUMENT', response.data)
  } else {
    console.log(response.error)
  }
}

export const loadFoldersTreeContent = async ({ commit, state }) => {
  let response = await CatalogApi.getFolders({ catalog_type: state.currentDocument.name })
  if (response.success) {
    commit('UPDATE_FOLDERS_TREE_CONTENT', response.data)
  } else {
    console.log(response.error)
  }
}

export const loadItemsTableContent = async ({ commit, state }) => {
  if (state.currentFolderId) {
    commit('SET_TABLE_LOADING', true)
    try {
      let response = await CatalogApi.getData({
        docId: state.currentDocument.id || 0,
        folder_id: state.currentFolderId,
        catalog_type: state.currentDocument.name
      })
      if (response.success) {
        commit('UPDATE_ITEMS_TABLE_CONTENT', response.data)
        commit('UPDATE_ITEMS_TABLE_QUANTITY')
      } else {
        console.log(response.error)
      }
    } catch (e) {
      console.log(e)
    }

    commit('SET_TABLE_LOADING', false)
  } else {
    commit('UPDATE_ITEMS_TABLE_CONTENT', [])
  }
}
export const resetItemsTableContent = ({ commit }) => {
  commit('UPDATE_ITEMS_TABLE_CONTENT', [])
}
export const resetItemsTableQuantity = async ({ commit }) => {
  commit('RESET_ITEMS_TABLE_QUANTITY')
}

export const refreshItemsTableQuantity = async ({ commit }) => {
  commit('RESET_ITEMS_TABLE_QUANTITY')
  commit('UPDATE_ITEMS_TABLE_QUANTITY')
}

// TODO temporary
export const updateDocName = async ({ commit, state }, payload) => {
  commit('UPDATE_DOC_NAME', payload)
}

export const beforeChangeQuantity = async ({ commit, state }, item) => {
  commit('SET_ERROR', false)
  const docName = state.currentDocument.name
  const itemIsSt = !!parseInt(item.st)
  // console.log(docName)
  // console.log(`itemIsSt: ${itemIsSt}`)
  // if there are no items in document, add any item
  if (!state.currentDocument.records.length) {
    return true
  }
  // check if item is already in doc and check if doc has 'st' items
  let itemInDocument = false
  let hasStItems = false
  state.currentDocument.records.forEach((element) => {
    if (parseInt(element.st)) {
      hasStItems = true
    }
    if (parseInt(element.nomenklatura_id) === parseInt(item.nomenklatura_id)) {
      itemInDocument = true
    }
  })
  // console.log(`hasStItems: ${hasStItems}`)
  // console.log(`itemInDocument: ${itemInDocument}`)
  if (!itemInDocument) {
    if (itemIsSt && !hasStItems) {
      commit('SET_ERROR', 'Выбранный товар является сборным. Вы не можете добавлять его в документ с обычными товарами. Создайте новый документ.')
      return false
    }
    if (!itemIsSt && hasStItems) {
      commit('SET_ERROR', 'В документ со сборными товарами нельзя добавлять обычные товары. Создайте новый документ.')
      return false
    }
  }
  if (docName === 'rezervirovanie') {
    // console.log(`itemInDocument: ${itemInDocument}`)
    if (!itemInDocument) {
      // console.log(`itemInDocument: ${itemInDocument}`)
      if (itemIsSt && hasStItems) {
        // console.log(`setError`)
        commit('SET_ERROR', 'В документ "Резервирование" можно добавлять только 1 готовое решение')
        return false
      }
    }
  }

  return true
}

export const saveDocument = async ({ commit, state }) => {
  let response = await DocumentsApi.saveDocument(state.currentDocument)
  return response
}

export const setSearchQuery = ({ commit, state }, payload) => {
  commit('SET_SEARCH_QUERY', payload)
}

export const searchItems = async ({ commit, state }) => {
  try {
    if (state.searchQuery.length >= 3) {
      commit('SET_TABLE_LOADING', true)
      let response = await CatalogApi.getData({
        docId: state.currentDocument.id || 0,
        search_query: state.searchQuery,
        catalog_type: state.currentDocument.name
      })
      if (response.success) {
        commit('UPDATE_ITEMS_TABLE_CONTENT', response.data)
        commit('UPDATE_ITEMS_TABLE_QUANTITY')
      } else {
        console.log(response.error)
      }
    }
  } catch (e) {
    console.log(e)
  } finally {
    commit('SET_TABLE_LOADING', false)
  }
}

export const setCurrentDocument = ({ commit }, currentDocument) => {
  commit('UPDATE_CURRENT_DOCUMENT', currentDocument)
}

export const setError = ({ commit }, payload) => {
  commit('SET_ERROR', payload)
}

export const setItemsDisplaySettings = ({ commit }, payload) => {
  commit('UPDATE_ITEM_DISPLAY_SETTINGS', payload)
}

export const setCurrentFolderId = ({ commit }, payload) => {
  commit('SET_CURRENT_FOLDER_ID', payload)
}

export const addRecordToDocument = ({ commit }, payload) => {
  commit('ADD_RECORD_TO_DOCUMENT', payload)
}

export const updateRecordToDocument = ({ commit }, payload) => {
  commit('UPDATE_RECORD_TO_DOCUMENT', payload)
}

export const deleteRow = ({ commit }, payload) => {
  commit('DELETE_ROW', payload)
}
export const setTableLoading = ({ commit }, payload) => {
  commit('SET_TABLE_LOADING', payload)
}
export const toggleTreeSideBar = ({ commit }) => {
  commit('TOGGLE_TREE_SIDEBAR')
}
